export default __webpack_public_path__ + "static/media/54.8c98a2b4.jpeg";